import Service from "../Service";

const resource = "inputoutputmaterial/";

export default {
    save(tiom, requestID) {
        return Service.post(resource + "save", tiom, {
            params: {requestID}
        });
    },

    pagination(parameters, requestID){
        return Service.post(resource + "pagination", parameters, {
            params: {requestID}
        });
    }
}